import {
  FETCH_SMTP,
  FETCH_SMTP_SUCCESS,
  FETCH_SMTP_FAILED
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';

export const fetchSMTP = () => async (dispatch) => {
  dispatch({
    type: FETCH_SMTP,
    payload: null,
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const { data, error } = await supabase
        .from('smtp_settings')
        .select('*')
        .limit(1)
        .maybeSingle();

      if (!error && data) {
        dispatch({
          type: FETCH_SMTP_SUCCESS,
          payload: {
            fromEmail: data.from_email || '',
            smtpDetails: {
              host: data.host || '',
              port: data.port || 587,
              secure: Boolean(data.secure),
              auth: {
                user: data.user_name || '',
                pass: data.password || '',
              },
            },
          },
        });
        return;
      }
    } catch (e) {
      // Tabela ainda não existe ou sem permissão temporária
    }
  }

  dispatch({
    type: FETCH_SMTP_SUCCESS,
    payload: {
      fromEmail: '',
      smtpDetails: {
        host: '',
        port: 587,
        secure: false,
        auth: { user: '', pass: '' },
      },
    },
  });
};

export const checkSMTP = async (fromEmail, smtpDetails) => {
  const supabase = getSupabase();
  if (supabase) {
    try {
      const payload = {
        from_email: fromEmail || '',
        host: smtpDetails?.host || '',
        port: smtpDetails?.port || 587,
        user_name: smtpDetails?.auth?.user || '',
        password: smtpDetails?.auth?.pass || '',
        secure: Boolean(smtpDetails?.secure),
        updated_at: new Date().toISOString(),
      };

      const { data: existing } = await supabase
        .from('smtp_settings')
        .select('id')
        .limit(1)
        .maybeSingle();

      if (existing?.id) {
        await supabase.from('smtp_settings').update(payload).eq('id', existing.id);
      } else {
        await supabase.from('smtp_settings').insert(payload);
      }
      return { success: true };
    } catch (e) {
      console.warn('[checkSMTP] Erro ao salvar smtp_settings:', e);
    }
  }
  return { success: true };
};